import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
export const wrapRootElement = ({ element }) => {
    /*return (
        <GoogleReCaptchaProvider reCaptchaKey="6LcyOdIZAAAAAFDlt8SgFTld174Wy29D4dEqC3WY">
            {element}
        </GoogleReCaptchaProvider>
    )*/
}
